module.exports = __webpack_public_path__ + "img/app-pzjp.73bc51b9.png";